/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React from 'react'
import { Link } from 'react-router-dom'
class ForWegoSideNavBar extends React.Component {
  render() {
    return (
      <nav
        className="pcoded-navbar noprint"
        id="admin_menu"
      >
        <div className="pcoded-inner-navbar main-menu">
          <div className="pcoded-navigatio-lavel">Master</div>
          <ul className="pcoded-item pcoded-left-item">
            <li className="">
              <Link to="/">
                <span className="pcoded-micon">
                  <i className="icofont icofont-sail-boat-alt-1"></i>
                </span>
                <span className="pcoded-mtext">Cruise Bookings</span>
              </Link>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i class="icofont icofont-settings"></i>
                </span>
                <span className="pcoded-mtext">Reports</span>
              </a>
              <ul className="pcoded-submenu">
                <li className="">
                  <Link to="/reports">
                    <span className="pcoded-mtext">Booking Report</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/user-booking-reports">
                    <span className="pcoded-mtext">User Booking Report</span>
                  </Link>
                </li>
                <li className="">
                  <Link to="/wego-new-user-reports">
                    <span className="pcoded-mtext">User Registered Report</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}

export default ForWegoSideNavBar
